import {
  ApolloClient,
  ApolloLink,
  concat,
  HttpLink,
  InMemoryCache,
} from "@noom/hive-core";
import { appConfig } from "src/config";
import {
  getAnonymousClientAuthorizationHeader,
  getAuthorizationHeader,
} from "./utils";

const httpLink = new HttpLink({
  uri: appConfig.GRAPHQL_URL,
});

const getMiddleware = (useAccessToken = true) => {
  return new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    const authorizationHeader = useAccessToken
      ? getAuthorizationHeader()
      : getAnonymousClientAuthorizationHeader();
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        ...authorizationHeader,
      },
    }));

    return forward(operation);
  });
};

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(getMiddleware(), httpLink),
});

export const apolloClientLoggedOutToken = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(getMiddleware(false), httpLink),
});
